import React from 'react';
import Resizable from 're-resizable';
import './CodemirrorEditor.css';
import { Controlled as CodeMirror } from 'react-codemirror2';
import * as commonVar from 'libs/commonVar';

require('codemirror/mode/xml/xml.js');
require('codemirror/mode/css/css');
require('codemirror/mode/javascript/javascript.js');

require('codemirror/lib/codemirror.css');

require('codemirror/theme/material.css');

require('codemirror/addon/edit/closebrackets');
require('codemirror/addon/edit/matchbrackets');
require('codemirror/addon/edit/closetag');

function CodemirrorEditor(props) {
  const { children, getMirrorHandler, curStep, data, isAuth } = props;
  /*
  * <결과 화면> 
  * 일본: 사용자 관리자(HTML만 사용), 슈퍼 관리자(HTML, CSS, JS 모두 사용)
  * 일본 외: HTML, CSS, JS 모두 사용
  */
  // JS, CSS 영역 사용 여부 판단
  const useJS = !!commonVar.isJapan ? (isAuth === 2 || curStep !== 3 ? true : false) : true;

  return (
    <div className="phishing-template-markup">
      <Resizable
        className="vertical-resizable"  
        maxWidth={1400}
        minWidth={300}
        defaultSize={{ width: 750 }}
        enable={{ right: true }}>
        <div className="left-side">
          <Resizable
            className="left-side-resizable"
            maxHeight={curStep && useJS ? 780 : '100%'}
            minHeight={80}
            defaultSize={{ height: curStep && useJS ? 441 : '100%' }}
            enable={{ bottom: curStep && useJS ? true : false }}>
            <div className="type-html code-area">
              <h2>HTML</h2>
              <CodeMirror
                value={data.html}
                autoScroll
                autoCursor
                options={{
                  mode: 'xml',
                  theme: 'material',
                  lineNumbers: true,
                  autoCloseTags: true,
                  styleActiveLine: true,
                  tabSize: 2
                }}
                onBeforeChange={(editor, data, value) => {
                  getMirrorHandler('html', curStep, value);
                }}
              />
            </div>
          </Resizable>
          {!!curStep && useJS && (
            <div className="type-js code-area">
              <h2>Javascript + No-Library(pure JS)</h2>
              <CodeMirror
                value={data.js}
                autoScroll
                autoCursor
                options={{
                  mode: 'javascript',
                  theme: 'material',
                  lineNumbers: true,
                  matchBrackets: true,
                  autoCloseBrackets: true,
                  styleActiveLine: true,
                  tabSize: 2
                }}
                onBeforeChange={(editor, data, value) => {
                  getMirrorHandler('js', curStep, value);
                }}
              />
            </div>
          )}
        </div>
      </Resizable>
      <div className="right-side">
        {!!curStep && useJS && (
          <Resizable
            className="right-side-resizable"
            maxHeight={780}
            minHeight={80}
            defaultSize={{ height: 441 }}
            enable={{ bottom: true }}>
            {!!curStep && (
              <div className="type-css code-area">
                <h2>CSS</h2>
                <CodeMirror
                  value={data.css}
                  autoScroll
                  autoCursor
                  options={{
                    mode: 'css',
                    theme: 'material',
                    lineNumbers: true,
                    matchBrackets: true,
                    autoCloseBrackets: true,
                    styleActiveLine: true,
                    tabSize: 2
                  }}
                  onBeforeChange={(editor, data, value) => {
                    getMirrorHandler('css', curStep, value);
                  }}
                />
              </div>
            )}
          </Resizable>
        )}
        {children}
      </div>
    </div>
  );
}

export default CodemirrorEditor;



// WEBPACK FOOTER //
// ./src/script/components/phishingTemplate/phishingTemplateModal/codemirror/codemirrorEditor/CodemirrorEditor.js